import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../app/i18n";
import { LoginFlow } from "../../shared/auth/LoginFlow";
import { guard } from "../../shared/auth/guards";
import { validateLoginSearch } from "../../shared/auth/search";

export const Route = createFileRoute("/app/login")({
  validateSearch: validateLoginSearch,
  beforeLoad: async (args) => {
    await Promise.all([guard("guestSeller", args), loadNamespaces("auth")]);
  },
  component: SellerLogin,
});

function SellerLogin() {
  const { redirect, notice, ref } = Route.useSearch();
  return <LoginFlow audience="seller" redirect={redirect} notice={notice} referral={ref} />;
}
